import axios from "axios";
import * as types from "./mutation-types";

/* eslint-disable */
export default {
  loginSuccess({ commit }, payload) {
    commit(types.LOGIN_SUCCESS, payload);
  },

  loginFailure({ commit }) {
    commit(types.LOGIN_FAILURE);
  },


  updateUser({ commit }, payload) {
    commit(types.UPDATE_USER, payload);
  },

  async logout({ commit }) {
    try {
      await axios.post("/logout-client");
    } catch (e) {}

    commit(types.LOGOUT);
  }
};
